<template>
  <main id="main">
    <section v-if="$page && riddle" class="section section__content riddle">
      <Transition name="page-slide-left">
        <div :key="id">
          <RiddleContent :riddle="riddle" @rendered="contextRendered = true" />
          <RiddleQuestion :ready="contextRendered" :riddle="riddle" />
        </div>
      </Transition>
      <Transition name="riddle-progress-transition">
        <RiddleProgress v-if="progressVisible" />
      </Transition>
    </section>
  </main>
</template>

<script>
import { RiddleContent, RiddleProgress, RiddleQuestion } from '@/components/riddle'
import { localizedRouteName } from '@/helpers'
import { UsesRoutesMixin } from '@/mixins'

export default {
  name: 'Riddle',
  beetPage: 'hunt_riddle',
  mixins: [UsesRoutesMixin],
  components: { RiddleContent, RiddleProgress, RiddleQuestion },
  data() {
    return {
      contextRendered: false,
      progressVisible: false,
    }
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    riddle() {
      return this.$store.state.riddle.all[this.id]
    },
  },
  mounted() {
    setTimeout(() => (this.progressVisible = true), 1000)
  },
  methods: {
    updateSeo() {
      if (this.$page && this.riddle)
        this.$store.dispatch('updateRiddleSeo', {
          count: this.riddle.order,
          seo: this.$page.seo,
        })
    },
  },
  watch: {
    id() {
      const currentRiddleId = this.$store.state.riddle.current.toString()
      if (this.id !== currentRiddleId) {
        this.$router.push({
          name: localizedRouteName(this.ROUTES.HUNT.RIDDLE),
          params: { id: currentRiddleId },
        })
      }
    },
    riddle() {
      this.updateSeo()
      this.contextRendered = false
    },
    $page() {
      this.updateSeo()
    },
  },
}
</script>
